module.exports = __webpack_public_path__ + "img/electric_use.9ba1c879.svg";